// Custom GA Click tracking

function init() {
	
	$('[data-ga]').on('touchstart, click', function(event) {
		track($(this).data('ga'));
	});


	$('[data-ecomm]').on('touchstart, click', function(event) {
		trackEcomm($(this).data('ecomm'));
	});
	
}

function track(value) {

	if (!window.dataLayer) {
		return;
	}
	
	var data = value.split('|'),
		tracker = {};
	
	if (data[0] == 'video') {
		
		tracker['event'] = data[1];
		tracker[data[2]] = data[3];
		tracker['Video Name'] = data[4];
		
	} else if (data[0] == 'zip') {
		
		tracker['event'] = data[1];
		tracker['flow step'] = data[2];
		tracker['zip'] = data[3];
		tracker[data[4]] = data[5];
		
	} else if (data[0] == 'zipCheck') {
		
		tracker['event'] = data[1];
		tracker['location'] = data[2];
		tracker['zip'] = data[3];
		tracker['coverage score'] = data[4];
		
	} else if (data[0] == 'device') {
		
		tracker['event'] = data[1];
		tracker['flow step'] = data[2];
		tracker['device'] = data[3];
		
		if (data[4]) {
			tracker[data[4]] = data[5];
		}
		
	} else if (data[0] == 'deviceCheck') {
		
		tracker['event'] = data[1];
		tracker['location'] = data[2];
		tracker['device'] = data[3];
		tracker['device result'] = data[4];
		
	} else if (data[0] == 'carousel') {

		tracker['event'] = data[1];
		tracker['selection'] = data[2];
		tracker['from card'] = data[3];
		tracker['to card'] = data[4];

	} else {
		
		tracker['event'] = data[0];
		
		if (data[1]) {
			tracker[data[1]] = data[2];
		}
	}

	window.dataLayer.push(tracker);

}

function trackEcomm(value) {
	
	if (!window.dataLayer) {
		return;
	}
	
	var data = value.split('|');

	if (data[0] == 'remove') {
		window.dataLayer.push({
			'event': 'removeFromCart',
			'ecommerce': {
				'remove': { // 'remove' actionFieldObject measures.
					'products': [{ // removing a product to a shopping cart.
						'name': data[1],
						'id': data[2],
						'price': data[3],
						'brand': data[4],
						'category': data[5],
						'variant': data[6],
						'quantity': data[7]
					}]
				}
			}
		});
	}
	
	if (data[0] == 'add') {
		window.dataLayer.push({
			'event': 'addToCart',
			'ecommerce': {
				'currencyCode': 'USD',
				'add': {
					'products': [{
						'name': data[1], // Product SKU
						'id': data[2], // Product SKU
						'price': data[3], // Product Price
						'brand': data[4],
						'category': data[5],
						'variant': data[6],
						'quantity': ($('.js-product-qty').length > 0) ? $('.js-product-qty').val() : data[7]
					}]
				}
			}
		});
	}


	if (data[0] == 'impression') {
		window.dataLayer.push({
			'ecommerce': {
				'currencyCode': 'USD',
				'impressions': [{
					'name': data[1], // Product SKU
					'id': data[2], // Product SKU
					'price': data[3], // Product Price
					'brand': data[4],
					'category': data[5],
					'variant': data[6],
					'position': data[7]
				}]
			}
		});
	}
	
	if (data[0] == 'click') {
		
		var list = (data[7]) ? data[7] : '';
		
		window.dataLayer.push({
			'event': 'productClick',
			'ecommerce': {
				'click': {
					'actionField': { 'list': list},
					'products': [{
						'name': data[1], // Product SKU
						'id': data[2], // Product SKU
						'price': data[3], // Product Price
						'brand': data[4],
						'category': data[5],
						'variant': data[6],
						'position': data[7]
					}]
				}
			}
		});
		
	}
	
	if (data[0] == 'shipping') {
		window.dataLayer.push({
			'event': data[1],
			'Zip': $('#calc_shipping_postcode').val()
		});
	}
	
	if (data[0] == 'promo') {
		window.dataLayer.push({
			'event': 'promotionClick',
			'ecommerce': {
				'promoClick': {
					'promotions': [{
						'id': data[1], // Location on page
						'name': data[2], // Use “data-ga” value for name*
						'creative': data[3], // Image file name
						'position': ''
					}]
				}
			}
		});
	}
	
	if (data[0] == 'checkoutOption') {
		window.dataLayer.push({
			"event": 'checkoutOption',
			"ecommerce": {
				"checkout_option": {
					"actionField": {
						"step": data[1],
						"option": data[2]
					}
				}
			}
		});
	}
}
	
export default {
	init,
	track,
	trackEcomm
};